import { meta } from '@/helpers/constants/router';
import { ECOMMERCE_PRODUCT_MENU_KEY, ECOMMERCE_ORDER_MENU_KEY, ECOMMERCE_CART_MENU_KEY, ECOMMERCE_MARKETING_MENU_KEY, CUSTOMER_SEGMENT, STORE_SETUP_MENU_KEY, } from '@/helpers/constants/app';
// lazy load components
// https://router.vuejs.org/guide/advanced/lazy-loading.html
const Products = () => import('@/views/v2/ecommerce/Products.vue');
const Categories = () => import('@/views/v2/ecommerce/Categories.vue');
const Wrapper = () => import('@/views/Wrapper.vue');
const Referrals = () => import('@/views/v2/Referrals.vue');
const ReferralList = () => import('@/components/v2/ReferralLinks.vue');
const SmartRetailLinks = () => import('@/components/v2/SmartRetailLinks.vue');
const productsTitle = 'Products';
const productsRouteName = 'ecommerce-products';
const cartSettingsRouteName = 'ecommerce-cart-settings';
const storeSetupRouteName = 'ecommerce-store-setup';
export default [
    {
        path: 'products',
        component: Wrapper,
        redirect: productsRouteName,
        meta: { ...meta, title: 'Products' },
        children: [
            {
                path: ':componentUUID',
                component: Wrapper,
                children: [
                    {
                        path: 'categories',
                        component: Wrapper,
                        meta,
                        children: [
                            {
                                path: '/',
                                name: 'ecommerce-categories',
                                component: Categories,
                                meta: {
                                    title: 'Categories',
                                    subtitle: 'Customize, add, or manage your categories here. Drag and drop to arrange category sequence.',
                                    parentMenu: ECOMMERCE_PRODUCT_MENU_KEY,
                                },
                            },
                            {
                                path: 'create',
                                name: 'ecommerce-categories-create',
                                component: () => import('@/views/v2/ecommerce/CategoryCreate.vue'),
                                meta: {
                                    title: 'Create Category',
                                    parentMenu: ECOMMERCE_PRODUCT_MENU_KEY,
                                },
                            },
                            {
                                path: ':uuid',
                                meta: { title: 'Categories' },
                                component: Wrapper,
                                children: [
                                    {
                                        path: 'edit',
                                        name: 'ecommerce-categories-update',
                                        component: () => import('@/views/v2/ecommerce/CategoryUpdate.vue'),
                                        props: true,
                                        meta: {
                                            title: 'Edit Category',
                                            parentMenu: ECOMMERCE_PRODUCT_MENU_KEY,
                                        },
                                    },
                                    {
                                        path: 'details',
                                        name: 'ecommerce-category-details',
                                        component: () => import('@/views/v2/ecommerce/CategoryDetails.vue'),
                                        props: true,
                                        meta: {
                                            title: 'Category Details',
                                            parentMenu: ECOMMERCE_PRODUCT_MENU_KEY,
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: '/',
                        name: productsRouteName,
                        component: Products,
                        meta: {
                            title: productsTitle,
                            parentMenu: ECOMMERCE_PRODUCT_MENU_KEY,
                            subtitle: 'Create or add new products here. ',
                        },
                    },
                    {
                        path: 'create',
                        name: 'ecommerce-products-create',
                        component: () => import('@/views/v2/ecommerce/ProductsCreate.vue'),
                        meta: {
                            title: 'Create Product',
                            subtitle: 'Add products and their details such as description, price, and variance here.',
                            parentMenu: ECOMMERCE_PRODUCT_MENU_KEY,
                        },
                    },
                    {
                        path: ':uuid',
                        component: Wrapper,
                        children: [
                            {
                                path: '/',
                                name: 'ecommerce-products-details',
                                component: () => import('@/views/v2/ecommerce/ProductDetails.vue'),
                                props: true,
                                meta: {
                                    title: 'Product Details',
                                    parentMenu: ECOMMERCE_PRODUCT_MENU_KEY,
                                },
                            },
                            {
                                path: 'edit',
                                name: 'ecommerce-products-edit',
                                component: () => import('@/views/v2/ecommerce/ProductsEdit.vue'),
                                props: true,
                                meta: {
                                    title: 'Edit Product',
                                    parentMenu: ECOMMERCE_PRODUCT_MENU_KEY,
                                },
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        path: 'redirect',
        component: Wrapper,
        meta: { ...meta, title: 'Redirect' },
        children: [
            {
                path: '/',
                name: 'redirector',
                meta: { title: 'REDIRECTOR' },
                component: () => import('@/views/v2/Redirector.vue'),
            },
        ],
    },
    {
        path: 'customers',
        component: Wrapper,
        meta: { ...meta, title: CUSTOMER_SEGMENT },
        children: [
            {
                path: '/',
                name: 'ecommerce-customers',
                meta: { title: CUSTOMER_SEGMENT, parentMenu: ECOMMERCE_MARKETING_MENU_KEY },
                component: () => import('@/views/v2/Customers.vue'),
            },
        ],
    },
    {
        path: 'overview',
        component: Wrapper,
        meta: { ...meta, title: 'Overview' },
        children: [
            {
                path: 'sales-funnel',
                component: Wrapper,
                meta: {
                    title: 'Overview',
                    redirect: 'ecommerce-overview',
                },
                children: [
                    {
                        path: '/',
                        name: 'ecommerce-sales-funnel',
                        component: () => import('@/views/v2/ecommerce/SalesFunnel.vue'),
                        meta: {
                            title: 'Sales Funnel',
                        },
                    },
                ],
            },
            {
                path: '/',
                component: Wrapper,
                meta: {
                    title: 'Overview',
                    redirect: 'ecommerce-overview',
                },
                children: [
                    {
                        path: '/',
                        name: 'ecommerce-overview',
                        component: () => import('@/views/v3/Overview.vue'),
                        meta: {
                            title: 'Overview',
                            subtitle: 'View your transaction data across all your sales channels in this dashboard.',
                        },
                    },
                    {
                        path: 'store-launch',
                        name: 'ecommerce-store-launch',
                        component: () => import('@/views/v3/prompts/StoreLaunchExplainer.vue'),
                        meta: {
                            title: 'Announce Your Messenger Store Launch',
                        },
                    },
                    {
                        path: 'latest-sold-products',
                        name: 'ecommerce-sold-products',
                        component: () => import('@/components/v2/ecommerce/LatestSoldProductsIndex.vue'),
                        meta: { title: `Today's Latest Sold Products` },
                    },
                    {
                        path: 'sales-amount',
                        name: 'ecommerce-sales-amount',
                        component: () => import('@/components/v2/ecommerce/SalesAmountIndex.vue'),
                        meta: { title: `Today's Sales Amount` },
                    },
                    {
                        path: 'latest-customers',
                        name: 'ecommerce-latest-customers',
                        component: () => import('@/components/v2/ecommerce/LatestCustomersIndex.vue'),
                        meta: { title: `Today's Latest Customers` },
                    },
                    {
                        path: 'top-referrals',
                        name: 'ecommerce-top-referrals',
                        component: () => import('@/components/v2/ecommerce/TopReferralsIndex.vue'),
                        meta: { title: `Top Referrals` },
                    },
                    {
                        path: 'low-inventory-products',
                        name: 'ecommerce-low-inventory-products',
                        component: () => import('@/components/v2/ecommerce/LowInventoryProductIndex.vue'),
                        meta: { title: `Low Inventory Products` },
                    },
                ],
            },
            {
                path: 'performance',
                component: Wrapper,
                meta: {
                    title: 'In-App Store Performance',
                    redirect: 'ecommerce-performance',
                },
                children: [
                    {
                        path: '/',
                        name: 'ecommerce-performance',
                        component: () => import('@/views/v2/ecommerce/Performance.vue'),
                        meta: {
                            title: 'In-App Store Performance',
                        },
                    },
                    {
                        path: 'popular-producs',
                        name: 'ecommerce-popular-products',
                        component: () => import('@/views/v2/ecommerce/PopularProductList.vue'),
                        meta: {
                            title: 'Most Viewed Products',
                            parentMenu: 'ecommerce-performance',
                        },
                    },
                    {
                        path: 'most-sold-producs',
                        name: 'ecommerce-profitable-products',
                        component: () => import('@/views/v2/ecommerce/ProfitableProductList.vue'),
                        meta: {
                            title: 'Most Sold Products',
                            parentMenu: 'ecommerce-performance',
                        },
                    },
                ],
            },
        ],
    },
    {
        path: 'store-setup',
        component: Wrapper,
        redirect: storeSetupRouteName,
        meta: { ...meta, title: 'Store Setup' },
        children: [
            {
                path: 'cart-settings',
                name: cartSettingsRouteName,
                component: () => import('@/views/v2/ecommerce/CartSetting.vue'),
                meta: {
                    title: 'Checkout Settings',
                    parentMenu: STORE_SETUP_MENU_KEY,
                    subtitle: 'Configure your desired checkout settings here.',
                },
            },
            {
                path: 'delivery-areas',
                component: Wrapper,
                redirect: 'ecommerce-delivery-areas',
                meta: { ...meta, title: 'Delivery Areas' },
                children: [
                    {
                        path: '/',
                        name: 'ecommerce-delivery-areas',
                        component: () => import('@/views/v2/apps/DeliveryAreas.vue'),
                        meta: {
                            title: 'Delivery Areas',
                            subtitle: 'View, add, and manage your saved delivery areas here.',
                            parentMenu: STORE_SETUP_MENU_KEY,
                        },
                    },
                    {
                        path: 'create',
                        name: 'ecommerce-delivery-areas-create',
                        component: () => import('@/views/v2/apps/DeliveryAreaCreate.vue'),
                        meta: {
                            title: 'Create Delivery Area',
                            subtitle: 'Designate your chosen delivery areas here.',
                            parentMenu: STORE_SETUP_MENU_KEY,
                        },
                    },
                    {
                        path: ':uuid',
                        component: Wrapper,
                        meta,
                        children: [
                            {
                                path: 'edit',
                                name: 'ecommerce-delivery-areas-edit',
                                props: true,
                                component: () => import('@/views/v2/apps/DeliveryAreaEdit.vue'),
                                meta: {
                                    title: 'Edit Delivery Area',
                                    parentMenu: STORE_SETUP_MENU_KEY,
                                },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'shipping-methods',
                component: Wrapper,
                redirect: 'ecommerce-shipping',
                meta: { ...meta, title: 'Shipping' },
                children: [
                    {
                        path: '/',
                        name: 'ecommerce-shipping',
                        component: () => import('@/views/v2/apps/ShippingMethods.vue'),
                        meta: {
                            title: 'Shipping',
                            subtitle: 'Manage your shipping methods',
                            parentMenu: STORE_SETUP_MENU_KEY,
                        },
                    },
                    {
                        path: 'create',
                        name: 'ecommerce-shipping-create',
                        component: () => import('@/views/v2/apps/ShippingMethodsCreate.vue'),
                        meta: {
                            title: 'Create Shipping Method',
                            subtitle: 'Configure your chosen shipping method here.',
                            parentMenu: STORE_SETUP_MENU_KEY,
                        },
                    },
                    {
                        path: ':uuid',
                        component: Wrapper,
                        meta,
                        children: [
                            {
                                path: 'edit',
                                name: 'ecommerce-shipping-edit',
                                props: true,
                                component: () => import('@/views/v2/apps/ShippingMethodsEdit.vue'),
                                meta: { title: 'Edit Shipping Method', parentMenu: STORE_SETUP_MENU_KEY },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'payment',
                redirect: 'ecommerce-payment',
                component: Wrapper,
                meta: { ...meta, title: 'Payment' },
                children: [
                    {
                        path: '/',
                        name: 'ecommerce-payment',
                        component: () => import('@/views/v2/Payments.vue'),
                        meta: {
                            title: 'Payment',
                            subtitle: 'Manage all your chosen payment methods here.',
                            parentMenu: STORE_SETUP_MENU_KEY,
                        },
                    },
                    {
                        path: 'merchant',
                        name: 'ecommerce-merchant-registration',
                        component: () => import('@/views/v2/MerchantPaymentRegistration.vue'),
                        meta: {
                            title: 'Merchant Registration',
                            parentMenu: STORE_SETUP_MENU_KEY,
                        },
                    },
                    {
                        path: 'kyc-verification',
                        name: 'ecommerce-kyc-verification',
                        component: () => import('@/views/v2/XenditKycVerification.vue'),
                        meta: {
                            title: 'Xendit Account KYC Verification',
                            parentMenu: STORE_SETUP_MENU_KEY,
                        },
                    },
                ],
            },
            {
                path: 'notifications',
                name: 'ecommerce-notifications',
                component: () => import('@/views/v2/NotificationsManager.vue'),
                meta: { ...meta, title: 'Notification Manager' },
                redirect: { name: 'ecommerce-notifications-manager-email' },
                children: [
                    {
                        path: 'fb-messenger',
                        name: 'ecommerce-notifications-manager-fb-messenger',
                        meta: {
                            title: 'Notification Manager',
                            subtitle: 'Create and manage your notifications here.',
                            parentMenu: 'ecommerce-notifications',
                        },
                        component: () => import('@/views/v2/NotificationsFbMessenger.vue'),
                    },
                    {
                        path: 'email',
                        name: 'ecommerce-notifications-manager-email',
                        meta: {
                            title: 'Notification Manager',
                            subtitle: 'Create and manage your notifications here.',
                            parentMenu: 'ecommerce-notifications',
                        },
                        component: () => import('@/views/v2/NotificationsEmail.vue'),
                    },
                ],
            },
        ],
    },
    {
        path: 'promos',
        component: Wrapper,
        redirect: 'ecommerce-promos',
        meta: { ...meta, title: 'Voucher' },
        children: [
            {
                path: '/',
                name: 'ecommerce-promos',
                component: () => import('@/views/v2/apps/PromoCodes.vue'),
                meta: {
                    title: 'Discounts',
                    parentMenu: STORE_SETUP_MENU_KEY,
                },
            },
            {
                path: 'create',
                name: 'ecommerce-promos-create',
                component: () => import('@/views/v2/apps/PromoCodeCreate.vue'),
                meta: {
                    title: 'Create Promo Code',
                    subtitle: 'Customize your promo codes here.',
                    parentMenu: ECOMMERCE_CART_MENU_KEY,
                },
            },
            {
                path: ':uuid',
                component: Wrapper,
                meta,
                children: [
                    {
                        path: 'edit',
                        name: 'ecommerce-promos-edit',
                        props: true,
                        component: () => import('@/views/v2/apps/PromoCodeEdit.vue'),
                        meta: { title: 'Edit Promo Code', parentMenu: ECOMMERCE_CART_MENU_KEY },
                    },
                ],
            },
            {
                path: 'add',
                name: 'ecommerce-automatic-discount-create',
                component: () => import('@/views/v2/apps/AutomaticDiscountCreate.vue'),
                meta: { title: 'Discounts', parentMenu: ECOMMERCE_CART_MENU_KEY },
            },
            {
                path: ':uuid',
                component: Wrapper,
                meta,
                children: [
                    {
                        path: 'edit',
                        name: 'ecommerce-automatic-discount-edit',
                        props: true,
                        component: () => import('@/views/v2/apps/AutomaticDiscountEdit.vue'),
                        meta: { title: 'Discounts', parentMenu: ECOMMERCE_CART_MENU_KEY },
                    },
                ],
            },
        ],
    },
    {
        path: 'cart-promos',
        component: Wrapper,
        redirect: 'ecommerce-cart-promos',
        meta: { title: 'Cart Promos' },
        children: [
            {
                path: '/',
                name: 'ecommerce-cart-promos',
                component: () => import('@/views/v2/apps/CartPromos.vue'),
                meta: {
                    title: 'Cart Promos',
                    parentMenu: ECOMMERCE_CART_MENU_KEY,
                    subtitle: 'View, manage, and add your cart promos here.',
                },
            },
            {
                path: 'create',
                name: 'ecommerce-cart-promos-create',
                component: () => import('@/views/v2/apps/CartPromoCreate.vue'),
                meta: {
                    title: 'Create Cart Promo',
                    subtitle: 'Create cart-specific promos here.',
                    parentMenu: ECOMMERCE_CART_MENU_KEY,
                },
            },
            {
                path: ':uuid',
                component: Wrapper,
                meta,
                children: [
                    {
                        path: 'edit',
                        name: 'ecommerce-cart-promos-edit',
                        props: true,
                        component: () => import('@/views/v2/apps/CartPromoEdit.vue'),
                        meta: {
                            title: 'Edit Cart Promo',
                            parentMenu: ECOMMERCE_CART_MENU_KEY,
                        },
                    },
                ],
            },
        ],
    },
    {
        path: 'meta-ad',
        component: Wrapper,
        redirect: 'meta-add-settings',
        meta: { ...meta, title: 'Meta Ad Settings' },
        children: [
            {
                path: '/',
                name: 'meta-add-settings',
                component: () => import('@/views/v2/apps/MetaAdSettings.vue'),
                meta: {
                    title: 'Meta Ad Settings',
                    parentMenu: ECOMMERCE_MARKETING_MENU_KEY,
                },
            },
        ],
    },
    {
        path: 'add-ons',
        component: Wrapper,
        redirect: 'ecommerce-add-ons',
        meta: { ...meta, title: 'Add - Ons / Upsell' },
        children: [
            {
                path: '/',
                name: 'ecommerce-add-ons',
                meta: {
                    title: 'Add - Ons / Upsell',
                    subtitle: 'Offer product add-ons and add their corresponding prices.',
                    parentMenu: ECOMMERCE_PRODUCT_MENU_KEY,
                },
                component: () => import('@/views/v2/apps/CartAddOns.vue'),
            },
            {
                path: 'create',
                name: 'ecommerce-add-ons-create',
                component: () => import('@/views/v2/apps/CartAddOnsCreate.vue'),
                meta: { title: 'Create Add-Ons', parentMenu: ECOMMERCE_PRODUCT_MENU_KEY },
            },
            {
                path: ':uuid',
                component: Wrapper,
                meta,
                children: [
                    {
                        path: 'edit',
                        name: 'ecommerce-add-ons-edit',
                        props: true,
                        component: () => import('@/views/v2/apps/CartAddOnsEdit.vue'),
                        meta: { title: 'Edit Add-Ons', parentMenu: ECOMMERCE_PRODUCT_MENU_KEY },
                    },
                ],
            },
        ],
    },
    {
        path: 'store-announcement-manager',
        component: Wrapper,
        meta: { ...meta, title: 'Store Announcement Manager' },
        children: [
            {
                path: '/',
                name: 'store-announcement-manager',
                props: true,
                component: () => import('@/views/v2/apps/StoreAnnouncementBanners.vue'),
                meta: {
                    title: 'Store Announcement Manager',
                },
            },
            {
                path: 'create',
                name: 'store-announcement-banner-create',
                component: () => import('@/views/v2/apps/StoreAnnouncementBannerCreate.vue'),
            },
            {
                path: ':uuid',
                meta: { title: 'Edit Announcements' },
                component: Wrapper,
                children: [
                    {
                        path: 'edit',
                        name: 'store-announcement-banner-edit',
                        component: () => import('@/views/v2/apps/StoreAnnouncementBannerEdit.vue'),
                        props: true,
                    },
                ],
            },
        ],
    },
    {
        path: 'orders',
        component: Wrapper,
        redirect: 'orders-by-status',
        meta: { ...meta, title: 'Orders' },
        children: [
            {
                path: 'history',
                name: 'ecommerce-order-history',
                meta: {
                    title: 'Order History',
                    subtitle: 'View and track all your orders here.',
                    parentMenu: ECOMMERCE_ORDER_MENU_KEY,
                },
                props: true,
                component: () => import('@/views/v2/ecommerce/OrderHistory.vue'),
            },
            {
                path: ':status/:filter?',
                component: () => import('@/views/v2/ecommerce/Orders.vue'),
                children: [
                    {
                        path: '/',
                        name: 'ecommerce-orders-by-status',
                        meta: {
                            title: 'Order Tracker',
                            subtitle: 'View all orders here.',
                            parentMenu: ECOMMERCE_ORDER_MENU_KEY,
                        },
                        props: true,
                        component: () => import('@/views/v2/ecommerce/OrdersByStatus.vue'),
                    },
                ],
            },
        ],
    },
    {
        path: 'broadcast',
        component: Wrapper,
        meta: { ...meta, title: 'Broadcast' },
        children: [
            {
                path: '/',
                name: 'ecommerce-broadcasts',
                meta: {
                    title: 'Broadcast',
                    subtitle: 'Send messages to customers for up to 24 hours since last contact.',
                    parentMenu: ECOMMERCE_MARKETING_MENU_KEY,
                },
                component: () => import('@/views/v2/Broadcast.vue'),
            },
        ],
    },
    {
        path: 'referrals',
        component: Wrapper,
        meta: { ...meta, title: 'Referrals' },
        children: [
            {
                path: '',
                component: Referrals,
                meta: { ...meta, title: 'Referrals' },
                children: [
                    {
                        path: 'referral',
                        name: 'ecommerce-referral',
                        meta: {
                            title: 'Referrals',
                            redirect: 'ecommerce-referral',
                            parentMenu: ECOMMERCE_MARKETING_MENU_KEY,
                        },
                        component: ReferralList,
                    },
                    {
                        path: 'smart-retail-links',
                        component: Wrapper,
                        meta: { ...meta, title: 'Referrals' },
                        children: [
                            {
                                path: '/',
                                name: 'ecommerce-smart-retail',
                                meta: {
                                    title: 'Smart Retail Links',
                                    redirect: 'ecommerce-smart-retail',
                                    parentMenu: ECOMMERCE_MARKETING_MENU_KEY,
                                },
                                component: SmartRetailLinks,
                            },
                        ],
                    },
                ],
            },
            {
                path: ':referralLinkUuid',
                component: Wrapper,
                meta,
                children: [
                    {
                        path: 'details',
                        name: 'ecommerce-referral-details',
                        meta: { title: 'Referral Details', parentMenu: ECOMMERCE_MARKETING_MENU_KEY },
                        component: () => import('@/views/v2/ReferralDetails.vue'),
                        props: true,
                    },
                ],
            },
        ],
    },
    {
        path: 'ecommerce-affiliate-automation',
        component: Wrapper,
        meta: { ...meta, title: 'Comment Auto-Reply' },
        children: [
            {
                path: '/',
                name: 'ecommerce-affiliate-automation',
                props: true,
                component: () => import('@/views/v2/AffiliateAutomation.vue'),
                meta: {
                    title: 'Comment Auto-Reply',
                    subtitle: "View your store's Comment Auto-Reply here.",
                },
            },
            {
                path: 'create',
                name: 'ecommerce-add-automation',
                meta: {
                    title: 'Add Comment Auto-Reply',
                    subtitle: "Configure your store's Comment Auto-Reply here.",
                },
                // component: () => import('@/views/v2/your_store/AffiliateAutomationCreate.vue'),
                component: () => import('@/views/v3/prompts/CommentAutoreply.vue'),
            },
            {
                path: ':uuid',
                meta: { title: 'Comment Auto-Reply' },
                component: Wrapper,
                children: [
                    {
                        path: 'edit',
                        name: 'ecommerce-edit-automation',
                        // component: () => import('@/views/v2/your_store/AffiliateAutomationCreate.vue'),
                        component: () => import('@/views/v3/prompts/CommentAutoreply.vue'),
                        props: true,
                        meta: {
                            title: 'Edit Comment Auto-Reply',
                            parentMenu: "Edit your store's Comment Auto-Reply here.",
                        },
                    },
                ],
            },
        ],
    },
    {
        path: 'faq-manager',
        component: Wrapper,
        meta: { ...meta, title: 'FAQ Manager' },
        children: [
            {
                path: '/',
                name: 'faq-manager',
                props: true,
                component: () => import('@/views/v2/apps/Faqs.vue'),
                meta: {
                    title: 'FAQ Manager',
                },
            },
            {
                path: 'create',
                name: 'faq-create',
                meta: {
                    title: 'Add FAQ',
                },
                component: () => import('@/views/v2/apps/FaqCreate.vue'),
            },
            {
                path: ':uuid',
                meta: { title: 'Edit FAQ' },
                component: Wrapper,
                children: [
                    {
                        path: 'edit',
                        name: 'faq-edit',
                        component: () => import('@/views/v2/apps/FaqEdit.vue'),
                        props: true,
                        meta: {
                            title: 'Edit FAQ',
                        },
                    },
                ],
            },
        ],
    },
    {
        path: 'inbox-manager',
        component: Wrapper,
        meta: { ...meta, title: 'Inbox Manager' },
        children: [
            {
                path: '/',
                name: 'inbox-manager',
                props: true,
                component: () => import('@/views/v3/inbox_manager/InboxManager.vue'),
                meta: {
                    title: 'Inbox Manager',
                },
            },
            {
                path: 'invite',
                name: 'invite-subscriber',
                props: true,
                component: () => import('@/views/v3/inbox_manager/InviteSubscriber.vue'),
                meta: {
                    title: 'Invite Subscriber',
                },
            },
            {
                path: 'messenger-notification',
                name: 'messenger-notification',
                props: true,
                component: () => import('@/views/v3/inbox_manager/MessengerNotification.vue'),
                meta: {
                    title: 'Messenger Notification',
                },
            },
        ],
    },
];
